module.exports = __webpack_public_path__ + "static/img/scout3.c85629d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/scout3.png
// module id = xUaH
// module chunks = 0